import { render, staticRenderFns } from "./FreeCourse.vue?vue&type=template&id=19226d12&scoped=true&"
import script from "./FreeCourse.vue?vue&type=script&lang=js&"
export * from "./FreeCourse.vue?vue&type=script&lang=js&"
import style0 from "./FreeCourse.vue?vue&type=style&index=0&id=19226d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19226d12",
  null
  
)

export default component.exports